<template>
    <div id="edit-client" class="wrap btn-position-wrap">
        <div class="client-box">
            <section class="global-section">
                <div class="row">
                    <md-button class="md-icon-button cancel-edit-client" @click="cancelEditClient()">
                        <md-icon>clear</md-icon>
                    </md-button>
                    <div class="col-3">
                        <h2 class="section-title">Edit Client Details</h2>
                        Required fields are marked with *
                    </div>
                    <div class="col-9">
                        <div class="row">
                            <div class="col-5">
                                <div class="line-item">
                                    <md-field class="md-block bigger-field without-line" md-no-float>
                                        <md-input v-model="currentClient.companyName" placeholder="Name *" @blur="touchHanlder('companyName')"></md-input>
                                    </md-field>
                                    <div class="client-error" v-if="$v.currentClient.companyName.$invalid">Please provide a unique name for the new client.</div>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input type="tel" v-model="currentClient.phoneNumber" placeholder="Phone *" @blur="touchHanlder('phoneNumber')"></md-input>
                                    </md-field>
                                    <div class="client-error" v-if="$v.currentClient.phoneNumber.$invalid">Please provide a valid phone number.</div>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.website" placeholder="Website (Example: https://example.io)" @blur="touchHanlder('website')"></md-input>
                                    </md-field>
                                    <div class="client-error" v-if="$v.currentClient.website.$error">Please provide a valid URL (Must include HTTP or HTTPS protocol).</div>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.country" placeholder="Country"></md-input>
                                    </md-field>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.stateProvince" placeholder="State/Province"></md-input>
                                    </md-field>
                                </div>
                                <div class="line-item">
                                    <div class="left-item">
                                        <md-switch v-model="isAnalytics" @change="toggleCurrentClientIsAnalytics($event)" class="md-primary">
                                            Analytics
                                        </md-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.address" placeholder="Address *" @blur="touchHanlder('address')"></md-input>
                                    </md-field>
                                    <div class="client-error" v-if="$v.currentClient.address.$invalid">Please provide an address.</div>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-textarea v-model="currentClient.description" placeholder="Description"></md-textarea>
                                    </md-field>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.city" placeholder="City"></md-input>
                                    </md-field>
                                </div>
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="currentClient.zipPostalCode" placeholder="Zip/Postal Code" @blur="touchHanlder('zipPostalCode')"></md-input>
                                    </md-field>
                                    <div class="client-error" v-if="$v.currentClient.zipPostalCode.$error">Please provide a valid postal code or zip number.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div v-if="!$v.$invalid && clientEdited" class="bottom-btn-position">
                <div class="wrap">
                    <md-button class="save-client-button md-primary" @click="saveClientChanges()">Save</md-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {required, url} from 'vuelidate/lib/validators';
import {updateClient} from '../../services/ClientService.js';
import {notWhitespace, validPhoneNumber, validPostalOrZip} from '../../includes/validations.js';

function uniqueClientName (value) {
  let clients = this.$store.getters['client/clientList'];
  let initialClientId = this.$store.getters['client/initialClient'].id;
  let unique = true;
  if (value) {
    for (let client of clients) {
      if (client.id !== initialClientId) {
        if (client.companyName.toLowerCase() === value.toLowerCase()) {
          unique = false;
        }
      }
    }
  }
  return unique;
}

export default {
  data: () => ({
    returnPath: null,
    isAnalytics: false
  }),
  computed: {
    ...mapGetters('client', ['currentClient', 'initialClient', 'clientEdited'])
  },
  methods: {
    ...mapActions('client', ['toggleCurrentClientIsAnalytics']),
    touchHanlder (key) {
      if (!this.$v.currentClient[key].$dirty) {
        this.$v.currentClient[key].$touch();
      }
    },
    cancelEditClient () {
      this.$router.push(this.returnPath);
    },
    async saveClientChanges () {
      await updateClient(this.currentClient)
        .then(response => {
          this.$router.push('/client/list');
        })
        .catch(error => {
          console.log(error.response.data.message);
        });
    }
  },
  validations: {
    currentClient: {
      companyName: {
        required,
        notWhitespace,
        uniqueClientName
      },
      phoneNumber: {
        required,
        notWhitespace,
        validPhoneNumber
      },
      address: {
        required,
        notWhitespace
      },
      zipPostalCode: {
        validPostalOrZip
      },
      website: {
        url
      }
    }
  },
  mounted () {
    this.returnPath = this.$store.state.RouterModule.from.fullPath;
    this.isAnalytics = this.currentClient.isAnalytics === 1;
  }
};
</script>
<style lang="scss" scoped>
.save-client-button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.client-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

#edit-client textarea {
    resize: none;
    height: 108px !important;
    min-height: 108px !important;
}

.cancel-edit-client {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/client/EditClient.vue